exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonify/index.js
// module id = 523
// module chunks = 0 1